module.exports = __webpack_public_path__ + "img/patient_info.af730b1c.png";